import { useQuery } from '@tanstack/react-query'
import { useState, useEffect } from 'react'
import { searchUsers } from '@/services/users/users'

export const useSearchUsers = (keyword: string, debounceMs: number = 300) => {
  const [debouncedKeyword, setDebouncedKeyword] = useState(keyword)

  // Debounce the keyword
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedKeyword(keyword)
    }, debounceMs)

    return () => {
      clearTimeout(timer)
    }
  }, [keyword, debounceMs])

  return useQuery({
    queryKey: ['users', 'search', debouncedKeyword],
    queryFn: () => searchUsers(debouncedKeyword),
    enabled: debouncedKeyword.trim().length > 0, // Only run query if keyword is not empty
    staleTime: 30000, // Consider data fresh for 30 seconds
  })
}
